/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".field-rule-container[_ngcontent-%COMP%]{border:1px solid #e4e4e4;border-radius:4px;padding:20px;margin-left:10px}"];
export { styles as styles };
